import type { LocalizationResources } from 'src/localization/resources/localization-resources.generated';
import productSupportedLocales from './product-supported-locales.generated';
export type ResourceFormatSource = { [slugName: string]: string } | (string | number)[];

export async function getResources(locale: string) {
	if (!productSupportedLocales[locale])
		locale = 'en';

	const localeResources = (await import(/* webpackChunkName: '[request]' */ `src/localization/resources/${locale}`)).default;
	return localeResources as LocalizationResources;
}

export function formatResource(template, source: ResourceFormatSource) {
	if (!template)
		return '';

	return template.replace(/\{(\w+)\}/ig, function (match: string, p1: string): string {
		let index: string | number = parseInt(p1, 10);
		if (isNaN(index))
			index = p1;

		let result = source[index] || '';

		if (result !== null && result !== undefined && typeof result !== 'string') {
			// Convert non string values to string
			result = result.toString();
		}

		return result;
	});
}